import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faAngleDoubleDown, faLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { urlFor } from '../../sanity';
import './index.scss';


const Project = ({ project }) => {

  return (

    <div className='headContainer'>
    <div className="projectContainer">

      <img className='ProjectImg' alt="project" src={urlFor(project.image)} />
 
      <div className="details">
        <a href={project.url} target="_blank" rel="noreferrer">
        <h2 className="title">{project.name} <FontAwesomeIcon icon={faLink} color='rgb(235, 253, 255)'width={26} /></h2></a>
        <a href={project.gitUrl} target="_blank" rel="noreferrer"><h3 className='gitHub'><FontAwesomeIcon icon={faGithub} /> Link to Github Repo</h3></a>
        
        
        <p className="description">{project.description}</p>
        <div className="stacksImg">
          {project.stacks.map((stack) => (
            <img alt="logo" width={38} src={urlFor(stack.image)} />
          ))}
        </div>
        <div className="stacks">
          {project.stacks.map((stack) => (
            <p>{stack.name}</p>
          ))}
        </div>
      </div>
    </div>
    <div className='arrowDown'> <FontAwesomeIcon icon={faAngleDoubleDown} color='rgb(235, 253, 255)'width={26} /></div>
  </div>

  );
};

export default Project;
